module.exports = __webpack_public_path__ + "static/img/line-solid.147b874.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/banner/line-solid.png
// module id = 171
// module chunks = 1